export default __webpack_public_path__ + "static/media/ball.0dc8769a.png";